/**
 * Device records currently share the same document category as service records.
 */
export const DEVICE_RECORDS_CATEGORY_ID = '69a9487003f8e4109a50ef14'

/**
 * Maximum number of documents allowed per device record.
 */
export const MAX_DOCUMENTS = 3
